export default __webpack_public_path__ + "static/testimonial-64d4a5edef73aed897021cd147d945e7.png";